import { useEffect, useState, useRef, useCallback } from 'react';

export const useDomAwareVisibility = (checkInterval = 100) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const checkVisibility = useCallback(() => {
    if (!ref.current) return;

    const rect = ref.current.getBoundingClientRect();
    
    const inViewport = (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );

    if (!inViewport) {
      setIsVisible(false);
      return;
    }

    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    
    const elementAtPoint = document.elementFromPoint(centerX, centerY);
    const isObscured = elementAtPoint !== ref.current && 
                      !ref.current.contains(elementAtPoint);

    setIsVisible(!isObscured);
  }, []);

  useEffect(() => {
    checkVisibility();
    
    const interval = setInterval(checkVisibility, checkInterval);
    window.addEventListener('scroll', checkVisibility);
    window.addEventListener('resize', checkVisibility);

    return () => {
      clearInterval(interval);
      window.removeEventListener('scroll', checkVisibility);
      window.removeEventListener('resize', checkVisibility);
    };
  }, [checkVisibility, checkInterval]);

  return { ref, isVisible };
};